import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { AppConfigService } from "@master/core/dist/core";
import { BaseService } from "./base.service";

@Injectable({
  providedIn: "root",
})

export class SendSmsService extends BaseService {
  
  constructor(
    private http: HttpClient,
    public appConfigService: AppConfigService
  ) {
    super(appConfigService)
  }

  sendSMS(params: any): Observable<any> {
    const configUrl = this.getUrl() + "/notifications/send-new-prevision-sms";
    return this.http.post(configUrl, {
      qr: params.qr,
      telefono: params.telefono,
      NAME1: params.NAME1,
      ARKTX: params.ARKTX,
      TKNUM: params.TKNUM,
      VBELN: params.VBELN,
      LDDAT: params.LDDAT,
      slot: params.slot,
    });
  }
}
